export function labelForCustomFieldValue(
  type: string,
  value: unknown,
  options?: Array<{ label: string; value: string }>,
): string | null {
  const kind = type.toLowerCase();
  if (kind === 'multiselect') {
    const items = Array.isArray(value)
      ? value.map((item) => String(item))
      : typeof value === 'string' && value
        ? [value]
        : [];
    if (items.length === 0) return null;
    return items.map((item) => options?.find((option) => option.value === item)?.label || item).join(', ');
  }
  if (kind === 'select' || kind === 'radio') {
    if (value == null || value === '') return null;
    const stored = String(value);
    return options?.find((option) => option.value === stored)?.label || stored;
  }
  return null;
}

export function customFieldMediaSrc(value: string | null | undefined): string | null {
  const raw = value?.trim();
  if (!raw) return null;
  if (raw.startsWith('/api/media/files/') || /^https?:\/\//i.test(raw)) return raw;
  if (/^[a-z0-9]{20,}$/i.test(raw)) return `/api/media/files/${raw}/content`;
  return null;
}

export function parseCustomFieldMediaIds(value: unknown): string[] {
  if (value == null || value === '') return [];
  if (Array.isArray(value)) return value.map((item) => String(item).trim()).filter(Boolean);
  const raw = String(value).trim();
  if (!raw) return [];
  if (raw.startsWith('[')) {
    try {
      const parsed = JSON.parse(raw) as unknown;
      if (Array.isArray(parsed)) return parsed.map((item) => String(item).trim()).filter(Boolean);
    } catch {
      /* keep as a single stored id */
    }
  }
  return [raw];
}
